<template>
  <el-dialog
    :visible="dialogShow"
    :before-close="beforeClose"
    :title="title"
    :close-on-click-modal="false"
    width="614px"
    class="wechat-list-dialog"
  >
    <div
      class="form-content"
      v-loading="loading"
      style="text-align: center;"
    >
      <div
        style="display: block;margin-bottom: 5px;"
      >
        <img
          class="qr-img"
          :src="loginQrCode" alt="登录二维码" />
      </div>
      <div class="tips display-flex justify-center">
        <icon-svg
          class="theme-color"
          icon-class="tongbu"
        ></icon-svg>
        <el-button
          type="text"
          style="margin-left: 5px;"
          @click="refreshQrCode"
        >刷新
        </el-button>
      </div>
      <div class="footer-text">扫码登录</div>
    </div>
  </el-dialog>
</template>

<script>

import {loginWechat} from "@/api/wechat/wechat-list";

export default {
  name: "qrCodeDialog",
  components: {
  },
  props: {
    dialogShow: {
      type: Boolean,
      default: false,
    },
    loginQrCode:{
      type: String,
      default:'',
    },
    loginBotId:{
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      title: '扫码登录',
      loading: false,
    }
  },
  methods: {
    beforeClose() {
      this.$emit('close');
    },
    confirm() {
    },
    submit(form) {
      let params = {
        ...form,
      }
      editWechat(params).then((data) => {
        if(data&&data.code&&data.code == 200){
          this.$message({
            message: '修改成功',
            type: 'success',
          });
          this.$emit('edit-success');
        }else{
          this.dialogShow = false;
          this.$message.error(data.msg);
        }
        
      }).catch((err) => {
        // this.$message.error(err.msg);
      })
    },
    refreshQrCode(){
      loginWechat(this.rowData.id).then((res) => {
        if (res && res.code === 200) {
          this.loading = false;
          this.$emit('refresh-success',res);
        } else {
          this.loading = false;
          this.$message.error(res.msg)
        }
      }).catch((error) => {
        this.loading = false;
      })
    }
  },
}
</script>

<style lang="scss" scoped>
.wechat-list-dialog {
  .form-content {
    text-align: center;
    font-size: 16px;
    color: #4B4B4B;
  }
  .icon-btn {
    font-size: 20px;
    font-weight: bold;
  }
  /deep/ .el-dialog__header {
    .el-dialog__title {
      font-weight: 500;
    }
    background-color: #F8F8F8;
    padding-bottom: 20px;
    .el-icon-close {
      color: #4B4B4B;
      font-weight: bold;
    }
  }
  /deep/ .el-dialog__body {
    //border-bottom: 1px solid #E0E4F2;
  }
  .footer {
    text-align: center;
  }
  .qr-img {
    width: 140px;
    height: 140px;
  }
  .footer-text {
    font-size: 20px;
  }
}
</style>
